var React = require('react');

function IconVideocollapse (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.671 9.26217L17.6915 9.27944C18.0868 9.61304 18.1046 10.1697 17.7311 10.5229C17.7183 10.535 17.7051 10.5468 17.6915 10.5583L12.7381 14.7378C12.3239 15.0874 11.6761 15.0874 11.2619 14.7378L6.30852 10.5583C5.91316 10.2247 5.89543 9.66795 6.26891 9.31482C6.28174 9.30269 6.29495 9.29089 6.30852 9.27944L6.32899 9.26217C6.74293 8.91289 7.39002 8.91257 7.80439 9.26145L11.2627 12.1732C11.6768 12.5218 12.3232 12.5218 12.7373 12.1732L16.1956 9.26145C16.61 8.91257 17.2571 8.91289 17.671 9.26217Z","fill":"white"}));
}

IconVideocollapse.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconVideocollapse;

IconVideocollapse.default = IconVideocollapse;
